// extracted by mini-css-extract-plugin
export var image = "floatImage-module--image--71217";
export var imageWrapper = "floatImage-module--imageWrapper--8bc92";
export var reverse = "floatImage-module--reverse--b785a";
export var subtitle = "floatImage-module--subtitle--b0544";
export var textWrapper = "floatImage-module--textWrapper--abb53";
export var wrapper = "floatImage-module--wrapper--c3e7a";